import type { AxiosError, AxiosInstance, AxiosResponse } from 'axios'
import type { ApiResponse, AxiosDataResponse } from '../../../config/api-types'
import { AUTHORIZATION_TOKEN_ENDPOINTS } from '../../../config/endpoints'
import type { GenerateTokenRequest, ValidateTokenRequest } from '../domain/models/reset-password'

export interface IAuthorizationTokenClient {
    generateToken(params: GenerateTokenRequest): Promise<ApiResponse>
    validateToken(params: ValidateTokenRequest): Promise<ApiResponse>
}

export class AuthorizationTokenService implements IAuthorizationTokenClient {
    constructor(private readonly axios: AxiosInstance) { }

    async generateToken(params: GenerateTokenRequest): Promise<ApiResponse> {
        try {
            const result: AxiosResponse<AxiosDataResponse> = await this.axios.post(
                AUTHORIZATION_TOKEN_ENDPOINTS.generateToken,
                params,
            )

            return {
                data: result.data.data,
                message: result.data.message,
                status: result.status,
                success: result.data.success,
            }
        } catch (error) {
            const axiosError = error as AxiosError<AxiosDataResponse>

            return {
                message: axiosError.response?.data?.message || 'Error al generar token',
                status: axiosError.response?.status || 500,
                success: false,
            }
        }
    }

    async validateToken(params: ValidateTokenRequest): Promise<ApiResponse> {
        try {
            const result: AxiosResponse<AxiosDataResponse> = await this.axios.post(
                AUTHORIZATION_TOKEN_ENDPOINTS.validateToken,
                params,
            )

            return {
                data: result.data.data,
                message: result.data.message,
                status: result.status,
                success: result.data.success,
            }
        } catch (error) {
            const axiosError = error as AxiosError<AxiosDataResponse>

            return {
                message: axiosError.response?.data?.message || 'Error al validar token',
                status: axiosError.response?.status || 500,
                success: false,
            }
        }
    }
}